import { Action, createFeature, createReducer, on } from '@ngrx/store';

import { LandingPage, initialState } from '../state/landing-page.state';
import * as landingPageActions from '../actions/landing-page.actions';

export const landingPageStoreKey: string = 'landingPage';

export const reducers = (state: LandingPage, action: Action): LandingPage => {
  return LandingPageReducer(state, action);
};

export const LandingPageReducer = createReducer(
  initialState,
  on(landingPageActions.setActiveSignButton, (state, { activeSignButton }) => ({
    ...state,
    activeSignButton,
  })),
  on(landingPageActions.signIn, (state) => ({
    ...state,
    isPasswordUpdated: false,
  })),
  on(landingPageActions.signInSuccess, (state, { signInResponse }) => ({
    ...state,
    signInResponse,
  })),
  on(landingPageActions.signUpSuccess, (state, { signUpResponse }) => ({
    ...state,
    signUpResponse,
  })),
  on(landingPageActions.resetPasswordSuccess, (state) => ({
    ...state,
    isOTPRequested: false,
    isPasswordUpdated: true,
  })),
  on(landingPageActions.resetPasswordError, (state) => ({
    ...state,
    isPasswordUpdated: false,
  })),
  on(landingPageActions.signInError, (state) => ({
    ...state,
    isSignInSuccess: false,
  })),
  on(landingPageActions.signUpError, (state) => ({
    ...state,
    isSignUpSuccess: false,
  })),
  on(landingPageActions.requestOTPSuccess, (state) => ({
    ...state,
    isOTPRequested: true,
  })),
  on(landingPageActions.requestOTPError, (state) => ({
    ...state,
    isOTPRequested: false,
  }))
);

export const landingPageFeature = createFeature({
  name: landingPageStoreKey,
  reducer: reducers,
});
